export default {
  // Contenu de base
  base: {
    ok: 'OK',
    done: 'Terminé',
    save: 'Sauvegarder',
    saving: 'En cours de préservation',
    notice: 'Notification',
    successfully: 'Avec succès',
    cancel: 'Annuler',
  },

  // Page de guide
  guide: {
    manageMyProfile: 'Se connecter (Propriétaire)',
    checkDogTagInfo: 'Vérifier le tag',
    languageSwitch: 'Changer de langue',
    'Tag ID does not exist. ': 'L\'ID du tag n\'existe pas.',
    'Please enter the dog tag ID.': 'Veuillez entrer l\'ID du tag.',
    about: 'l\'ID du tag',
    info: [
      'Cette plaque d’identité intelligente aide les animaux perdus à rentrer chez eux.',
      '🐾 Si vous avez trouvé un chien portant une médaille PETHEY, appuyez sur « Se connecter (Propriétaire) » et entrez l’ID de la médaille indiqué sous le code QR pour contacter le propriétaire.',
      '👤 Si vous êtes propriétaire d’un animal de compagnie, appuyez sur « Vérifier le tag » pour créer et gérer le profil de votre chien.',
      'Entrez l’ID de l’étiquette sous le code QR pour afficher les informations de l’animal et contacter son propriétaire.'
    ],
    guideBtn: 'Guide d’utilisation'
  },

  // Page de connexion
  login: {
    'Register': 'S\'inscrire',
    'Log in to your': 'Connectez-vous à votre',
    'Account': 'Compte',
    'Please enter your email address': 'Veuillez entrer votre adresse e-mail',
    'Please enter your password': 'Veuillez entrer votre mot de passe',
    'Enter code': 'Entrez le code',
    'Login with code': 'Se connecter avec un code',
    'Please input email and password': 'Veuillez saisir l\'e-mail et le mot de passe',
    'Login with password': 'Se connecter avec le mot de passe',
    'Please input email and code': 'Veuillez saisir l\'e-mail et le code',
    'Get code': 'Obtenir un code',
    'Please enter email address': 'Veuillez entrer une adresse e-mail',
    'Email sent successfully': 'E-mail envoyé avec succès',
    'Email send failed': 'Échec de l\'envoi de l\'e-mail',
    'Forget Password': 'Mot de passe oublié',
    'Log In': 'Se connecter',
    'Cannot connect to server': 'Impossible de se connecter au serveur',
    'fetching user data error': 'Erreur lors de la récupération des données utilisateur',
    'Please agree to the agreement': 'Veuillez accepter l\'accord',
    'User Agreement': 'Accord d\'utilisateur',
    'User Agreement Content': '--------------------------------------------',
    'Privacy Agreement': 'Accord de confidentialité',
    'Privacy Agreement Content': 'Consumer Business Privacy Statement\n' +
      'Introduction\n' +
      'The website and its global affiliates (collectively referred to as "the website," "we," or "our") value your privacy. We have developed this Privacy Statement (hereinafter referred to as "this Statement") to help you understand how we collect, use, disclose, protect, store, and transmit your personal data. Please read this Statement carefully and feel free to contact us if you have any questions.\n' +
      'This Statement applies to all website products and services that display or mention this Statement, including QR tags, software, toolkits, websites, and other services.\n' +
      'In addition, we recommend that you carefully read the Privacy Statement or supplementary notice related to specific products or services (hereinafter referred to as the "Product Privacy Notice"). The Product Privacy Notice is an integral part of this Statement and provides detailed descriptions on how each product or service processes your personal data. If any conflicts arise between this Statement and the Product Privacy Notice, the latter shall prevail.\n' +
      '\n' +
      '1. How the Website Collects Your Personal Data\n' +
      '1.1 Definition of Personal Data\n' +
      'Personal data refers to any information related to an identified or identifiable natural person, excluding anonymized data. When you use our products or services or interact with us, we may collect your personal data. The types of data collected will vary based on the specific service and your interactions with us. In certain cases, you may choose not to provide this data, but this may affect the normal use of certain services or result in us being unable to process your request.\n' +
      'We may also collect statistical data (such as visit frequency, code request frequency, and product quantities) to analyze how our products and services are used. Such statistical data is considered non-personal data. However, if non-personal data is mixed with personal data, we will treat the entire dataset as personal data.\n' +
      '\n' +
      '1.2 Types of Personal Data We May Collect\n' +
      '(1) Personal Data Provided by You\n' +
      '● Account Registration and Service Usage:When you register or log in to your website ID to add or delete tags or purchase services, we may collect your name, email address, mobile number, and other information.\n' +
      '\n' +
      '● Interaction and Sharing with Others:Some products allow you to communicate and share content with others. When using these features, you may need to create a public user profile that includes your nickname and avatar. We will also collect the contact information you provide (such as email addresses and phone numbers) to ensure communication security.\n' +
      '\n' +
      '● Identity Verification and Payment Requirements:To comply with local laws, such as those for real-name registration, anti-addiction systems, and online payments, we may need to collect government-issued identity proof or card information to verify your identity.\n' +
      '\n' +
      '(2) Data Collected Automatically During Service Use\n' +
      '● Device and Account Information: This includes device name, device identifier, activation time, hardware model, OS version, app version, region, and language settings.\n' +
      '● Log Information: Includes access time, access count, IP address, error and crash logs, and other log information.\n' +
      '● Location Information: When you scan a QR tag, we may collect location information from your device (via GPS). You may disable location permissions in your device settings.\n' +
      '\n' +
      '2. How We Use Your Personal Data\n' +
      'We will use your personal data based on legally permissible grounds. The purposes include, but are not limited to:\n' +
      '1. Registering and activating products or services you have purchased;\n' +
      '2. Providing a personalized user experience, with an option for you to decline personalization;\n' +
      '3. Sending marketing information or invitations to promotional events after obtaining your consent;\n' +
      '4. Conducting internal data analysis, business research, and auditing;\n' +
      '5. Improving our loss prevention and anti-fraud programs;\n' +
      '6. Displaying your contact information (such as phone number) when someone scans your QR tag.\n' +
      '\n' +
      '3. Cookies and Similar Technologies\n' +
      'We may use cookies, pixel tags, and local storage technologies to enhance your experience.\n' +
      '● Necessary Cookies: Help users log in and save preferences.\n' +
      '● Analytical Cookies: Used for statistical analysis of user behavior.\n' +
      '● Advertising Cookies: Provide personalized advertisements based on your interests.\n' +
      'You can manage or delete cookies through your browser, but disabling cookies may affect the functionality of certain services.\n' +
      '\n' +
      '4. How We Entrust, Share, Transfer, and Disclose Your Personal Data\n' +
      '4.1 Entrustment\n' +
      'We may entrust third parties to provide services such as customer support or technical support. These third parties can only process data under our supervision and in accordance with our instructions. They are required to implement confidentiality measures and must not retain this data after the entrustment contract ends.\n' +
      '4.2 Sharing\n' +
      'We will only share your data with third parties under the following circumstances:\n' +
      '1. With your consent, sharing with designated third parties;\n' +
      '2. When legally required, sharing with regulatory agencies;\n' +
      '3. Sharing with business partners: For instance, sharing order information with logistics companies for delivery purposes.\n' +
      '4.3 Data Transfer\n' +
      'In the event of company mergers, divisions, or bankruptcy involving data transfer, we will notify you in advance and obtain your consent if necessary.\n' +
      '4.4 Public Disclosure\n' +
      'We will only publicly disclose your personal data with your consent or when required by law.\n' +
      '\n' +
      '5. Managing Your Personal Data\n' +
      'You have the right to access, correct, or delete your personal data, and may withdraw your consent for data processing at any time. To exercise these rights, please contact our customer service channels.\n' +
      '\n' +
      '6. Cross-Border Data Transfers\n' +
      'As a global company, your data may be processed in different countries or regions. We ensure that data is processed in accordance with this Statement and applicable laws.\n' +
      '\n' +
      '7. Updates to This Statement\n' +
      'We reserve the right to update this Statement at any time. For major changes, we will notify you via a website notice or direct communication.\n' +
      '\n' +
      '8. Contact Us\n' +
      'If you have any questions or suggestions, please contact us via online customer service or email at service@petheylife.com. We will respond to your request within the time frame specified by law.\n' +
      '\n' +
      'Copyright Statement\n' +
      'Copyright © The Website. All rights reserved.Last Updated: October 23, 2024\n',
    'I have read and agree': 'J\'ai lu et j\'accepte',
    'and': 'et',
  },

  // Page d\'inscription
  reg: {
    'Invalid email verification code': 'Code de vérification de boîte aux lettres invalide. ',
    'Login': 'Se connecter',
    'Register': 'S\'inscrire',
    'Your Account': 'Votre compte',
    'Email': 'E-mail',
    'Please confirm your password': 'Veuillez confirmer votre mot de passe',
    'Name': 'Nom',
    'Contact number': 'Numéro de contact',
    'Dog Tag ID': 'ID du tag',
    'Please enter your name': 'Veuillez entrer votre nom',
    'Please enter your phone number': 'Veuillez entrer votre numéro de téléphone',
    'Please enter your dog tagId': 'Veuillez entrer l\'ID de votre tag',
    'Email address not valid.': 'Adresse e-mail non valide.',
    'Password must not less then 6 characters.': 'Le mot de passe doit contenir au moins 6 caractères.',
    'Password mismatch.': 'Les mots de passe ne correspondent pas.',
    'Please input dog tag Id.': 'Veuillez saisir l\'ID du tag.',
    'Registered successfully': 'Inscription réussie',
    'Register your details to': 'Inscrivez vos détails pour activer le tag de votre animal. Cela nous aide à garantir que votre animal puisse toujours retrouver son chemin vers vous s\'il se perd.'
  },

  // Page du centre personnel
  person_center: {
    'Pet Profile': 'Animaux',
    'My Account': 'Mon compte',
    'Setting': 'Paramètres',
    'Are you sure you want to logout?': 'Êtes - vous sûr de vouloir vous déconnecter?',
  },

  // Page de liste des animaux
  person_list: {
    'Add a New Profile': 'Ajouter un nouveau profil',
    'Fetch list failed.': 'Échec du chargement de la liste.',
    'unbind title': 'Débrancher la liaison',
    'unbind info': 'Êtes - vous sûr de vouloir dissocier?',
  },

  // Page de détails de l\'animal
  checked_info: {
    'Please contact my owner to help find me': 'Veuillez contacter mon propriétaire pour m\'aider à me retrouver'
  },

  // Page d\'édition des informations de l\'animal
  edit_info: {
    'Click to choose profile picture': 'Cliquez pour choisir une photo de profil',
    'Nickname': 'Pseudo',
    'Required': 'Requis',
    'Optional': 'Facultatif',
    'Breed': 'Race',
    'Birth': 'Naissance',
    'Size': 'Taille',
    'Special Need': 'Besoins spéciaux',
    'Please upload image': 'Veuillez télécharger une image',
    'The image cannot large than 10MB': 'L\'image ne peut pas être plus grande que 10 Mo',
    'Upload image error': 'Erreur de téléchargement de l\'image',
    'Please enter nickname': 'Nom du chien manquant',
    'Please enter Dog Tag ID': 'Entrez l\'ID chien'
  },

  // Page d\'édition des informations personnelles
  edit_profile: {
    'Pet Owner Profile': 'Profil du propriétaire',
    'Contact number': 'Numéro de contact',
    'Please enter your nickname': 'Veuillez entrer votre pseudo',
    'Please enter your contact number': 'Veuillez entrer votre numéro de contact'
  },

  // Page de modification du mot de passe
  update_pwd: {
    'change': 'changer',
    'Password': 'Mot de passe',
    'Please enter your old password': 'Veuillez entrer votre ancien mot de passe',
    'Please enter your new password': 'Veuillez entrer votre nouveau mot de passe',
    'Please confirm your new password': 'Veuillez confirmer votre nouveau mot de passe',
    'Please enter your current password': 'Veuillez entrer votre mot de passe actuel',
    'Please enter your password': 'Veuillez entrer votre mot de passe',
    'Change successfully': 'Changement réussi'
  },

  // Page d\'oubli du mot de passe
  forget_pwd: {
    'Forget': 'Oublié',
    'Change Password': 'Changer le mot de passe'
  },
}



// WEBPACK FOOTER //
// ./src/i18n/fr-FR.js